export const blogs = [
  {
    title: "GopherCon UK 2023",
    fileName: "2024_01_02_gophercon_2023",
  },
  {
    title: "A Software Engineer at a Climate Change Conference",
    fileName: "2023_07_11_net_zero",
  },
  {
    title: "Lessons in MLOps: How To Prioritise Automation",
    fileName: "2022_11_02_lessons_in_ml_ops",
  },
  {
    title: "Building a Mini Data Warehouse with Athena and Kafka Connect",
    fileName: "2022_10_24_mini_data_warehouse",
  },
];
